<template>
  <div class="main">
    <!-- <div class="zhezhaoBox" v-if="!isShow">
      <div class="addressBox">
        <p>需要获取您的位置</p>
        <img
          src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/delete.png"
          alt=""
          @click="colse"
        />
        <div class="caozuo">
          <div class="cancel" @click="colse">拒绝</div>
          <div class="confirm">接受</div>
        </div>
      </div>
    </div> -->

    <!-- v-if="isShow" -->
    <div class="topBox">
      <!-- <img :src="objMsg.img" alt="" /> -->
      <div class="name">
        {{ objMsg.name }}
      </div>
    </div>
    <div class="dibuBox">
      <audio
        id="myAudio"
        src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/yinpin.mp4"
      ></audio>
      <div class="msgMain">
        <div class="playItem">
          <div class="playLeft">Play me：</div>
          <div class="ypRight" @click="toBo">
            <img
              src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/bofang.png"
              alt=""
            />
            <img
              src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/xiaoguo.png"
              alt=""
            />
          </div>
        </div>
        <div class="playItem">
          <div class="playLeft">家长电话：</div>
          <div class="playRight">
            <span>{{ objMsg.phone }}</span>
            <a :href="`tel:${objMsg.phone}`">一键拨打</a>
          </div>
        </div>
        <!-- <div class="playItem">
          <div class="playLeft">母亲电话：</div>
          <div class="playRight">
            <span>{{ objMsg.mtPhone }}11111111111</span>
            <a :href="`tel:${objMsg.ftPhone}`">一键拨打</a>
          </div>
        </div> -->
        <div class="playItem">
          <div class="playLeft">幼儿园电话：</div>
          <div class="playRight">
            <span>17331652726</span>
            <a href="tel:17331652726">一键拨打</a>
          </div>
        </div>
        <div class="playItem">
          <div class="playLeft">学校名称：</div>
          <div class="schoolRight">北京燕京实验幼儿园</div>
        </div>
      </div>

      <div class="imgBox">
        <img
          src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/yeyLogo.png"
          alt=""
        />
        <img
          src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/stLogo.png"
          alt=""
        />
        <img src="https://lwjkimg.oss-cn-beijing.aliyuncs.com/ewm.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  stuName: "h5page",
  data() {
    return {
      // isShow: false,
      objMsg: {
        phone: "",
        img: "",
        name: "",
      },
    };
  },
  created() {},
  mounted() {
    // 测试nfc跳转功能
    // console.log(this.$route.query.phone); // 使用 this.$route.query.q 获取查询参数值
    this.objMsg.phone = this.$route.query.phone;
    this.objMsg.name = this.$route.query.name;
    // this.objMsg.img = this.$route.query.img;99
    // this.objMsg.phone = "111111";
    // this.objMsg.name = "测试";
    // http://60.247.2.76:10086
    // 192.168.31.5:10086
    axios
      .get("http://60.247.2.76:10086/system/nfc/addNfc", {
        params: this.objMsg,
      })
      .then((response) => {})
      .catch((error) => {});
  },
  methods: {
    colse() {
      this.isShow = true;
    },
    toBo() {
      // 获取audio元素
      var audio = document.getElementById("myAudio");
      audio.play();
    },
  },
};
</script>
<style scoped>
.main {
  width: 100vw;
  height: 100vh;
  background-image: url("https://lwjkimg.oss-cn-beijing.aliyuncs.com/origin.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.topBox {
  width: 250px;
  padding-top: 70px;
  margin: 0 auto;
}
.topBox img {
  width: 250px;
  height: 250px;
  background: #6d6d6d;
  border-radius: 45px 45px 45px 45px;
}
.name {
  font-family: UnifrakturCook, UnifrakturCook;
  font-weight: bold;
  font-size: 20px;
  color: white;
  letter-spacing: 1px;
  text-align: center;
  margin-top: 100px;
}

.zhezhaoBox {
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.87);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.addressBox {
  width: 275px;
  height: 175px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 2px rgba(140, 140, 140, 0.45);
  border-radius: 16px;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
}
.addressBox p {
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 24px;
  color: #212121;
  text-align: center;
  margin-top: 60px;
}
.addressBox img {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 18px;
  right: 20px;
}
.caozuo {
  width: 80%;
  height: 40px;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
  margin-top: 20px;
}
.cancel {
  width: 73px;
  height: 25px;
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
  text-align: center;
  line-height: 25px;
  border: 1px solid black;
  border-radius: 70px;
}
.confirm {
  width: 73px;
  height: 25px;
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
  text-align: center;
  line-height: 25px;
  border-radius: 70px;
  background: #ffe500;
}

.dibuBox {
  width: 100vw;
  height: 360px;
  position: fixed;
  bottom: 0;
  left: 0;
}

.msgMain {
  width: 100%;
  height: 260px;
  background: white;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
}
.imgBox {
  width: 80%;
  height: 100px;
  padding: 0 10%;
  display: flex;
  justify-content: space-around;
  background: #ffe500;
}
.imgBox img {
  width: 55px;
  height: 55px;
  padding: 22.5px 0;
}

.playItem {
  width: 90%;
  height: 50px;
  margin: 0 auto;
  border-bottom: 1px solid #a8a8a8;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}
.playLeft {
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
  line-height: 50px;
}

.playRight {
  width: 200px;
  padding: 0 25px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
}
.playRight span {
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 12px;
  color: #666666;
}
.playRight a {
  width: 73px;
  height: 23px;
  background: #ffe500;
  border-radius: 69px 69px 69px 69px;
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
  text-align: center;
  line-height: 23px;
  margin-top: 13.5px;
  text-decoration: none;
}

.schoolRight {
  width: 200px;
  padding: 0 25px;
  line-height: 50px;
  font-family: Adobe Heiti Std, Adobe Heiti Std;
  font-weight: normal;
  font-size: 12px;
  color: #666666;
}
.ypRight {
  width: 220px;
  padding: 0 15px;
  height: 23px;
  background: #ffe500;
  margin-top: 15px;
  border-radius: 69px 69px 69px 69px;
  position: relative;
}
.ypRight img:nth-child(1) {
  width: 10px;
  height: 10px;
  position: absolute;
  left: 25px;
  top: 50%;
  transform: translateY(-50%);
}

.ypRight img:nth-child(2) {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 120px;
  top: -3px;
}
</style>